// src/components/NotificationDropdown.jsx
import React, { useEffect, useState } from 'react';
import './Notifications.scss';
import { getNotification, updateUnseenNotification } from '../../services/api/NotificationsApi';
import { useNavigate } from 'react-router-dom';
import { useBubbleSettings } from '../../context/BubbleSettingsContext';

export const Notifications = ({ show }) => {
  const [notifications, setNotifications] = useState([]);
  const [notifyCount, setNotifyCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const { fetchAndUpdateBubbleSettings } = useBubbleSettings();

  const handleNotificationClick = async (notif) => {
    try {
      await updateUnseenNotification(notif._id);
      await fetchAndUpdateBubbleSettings();
      console.log('Notification marked as seen');

      switch (notif.module) {
        case 'Task':
          navigate(`/home/tasks/viewtask/${notif.source}`);
          break;
        case 'Document':
          navigate(`/home/cases/casedetails/${notif.courtRef}/additonaldoc/${notif.source}`);
          break;
        case 'Case':
          navigate(`/home/cases/${notif.source}`);
          break;
        case 'Case-Assignment':
          navigate(`/home/cases/casedetails/${notif.courtRef}`);
          break;
        case 'Expense':
          navigate(`/home/expenses/${notif.source}`);
          break;
        default:
          console.warn('No route defined for module:', notif.module);
          break;
      }
    } catch (error) {
      console.error('Error updating notification status:', error);
    }
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      setLoading(true);
      try {
        const res = await getNotification();
        console.log(res.data, "nnnnn")
        setNotifyCount(res.data.unSeenNotifications)
        const data = res.data.result || [];
        setNotifications(data);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        setLoading(false);
      }
    };

    if (show) fetchNotifications();
  }, [show]);

  if (!show) return null;

  return (
    <div className="notification-box">
      <h4>Notifications ({notifyCount})</h4>
      {loading ? (
        <p>Loading...</p>
      ) : notifications.length === 0 ? (
        <p>No notifications</p>
      ) : (
        <div className="notification-scroll-container">
          {notifications.map((notif) => (
            <div
              key={notif._id}
              className="notification-item"
              onClick={() => handleNotificationClick(notif)}
            >
              <div className='notif-per-item'>
              <span>
                {notif.action} by <strong>{notif.byUser.name}</strong> to <strong>{notif.toUser.name}</strong>
              </span>
              <div className="timestamp">
                {new Date(notif.createdAt).toLocaleString()}
              </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

  );
};
